import { useCollateralDialog } from './logic/useCollateralDialog'
import { CollateralView } from './views/CollateralView'
import { SuccessView } from './views/SuccessView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { DialogContentContainerProps } from '@/features/dialogs/common/types'
import { withSuspense } from '@/ui/utils/withSuspense'

interface CollateralDialogContentContainerProps extends DialogContentContainerProps {
  useAsCollateral: boolean
  chainId: number
}

function CollateralDialogContentContainer({
  useAsCollateral,
  token,
  chainId,
  closeDialog,
}: CollateralDialogContentContainerProps) {
  const {
    collateral,
    collateralBalance,
    validationIssue,
    currentHealthFactor,
    updatedHealthFactor,
    pageStatus,
    riskAcknowledgement,
    actionsViewState,
  } = useCollateralDialog({
    useAsCollateral,
    token,
    chainId,
  })
  const collateralSetting = useAsCollateral ? 'enabled' : 'disabled'

  if (pageStatus.state === 'success') {
    return <SuccessView collateralSetting={collateralSetting} token={token} onProceed={closeDialog} />
  }

  return (
    <CollateralView
      collateralSetting={collateralSetting}
      collateral={collateral}
      collateralBalance={collateralBalance}
      validationIssue={validationIssue}
      currentHealthFactor={currentHealthFactor}
      updatedHealthFactor={updatedHealthFactor}
      riskAcknowledgement={riskAcknowledgement}
      actionsViewState={actionsViewState}
    />
  )
}

const CollateralDialogContentContainerWithSuspense = withSuspense(
  CollateralDialogContentContainer,
  DialogContentSkeleton,
)
export { CollateralDialogContentContainerWithSuspense as CollateralDialogContentContainer }
